





































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetExamResultList } from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private id: any;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private goResult(item: any) {
    this.$router.push({
      path: "/main/teacher/exam-condition",
      query: {
        id: item.exam_result_id,
      },
    });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      exam_id: this.id,
      search: this.filters.search,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetExamResultList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (localStorage.getItem("examResultFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("examResultFilter") as any
      );
    }
    this.getList();
  }
}
